import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { CaptionPipe } from 'src/app/core/_base/layout/pipes/caption.pipe';
import { CatalogueService, CatalogCategory } from 'src/app/provider/catalogue.service';
import { ItemService } from 'src/app/provider/item.service';
import { MenuItemCatalogGroupModel } from 'src/app/views/models/menu-item-catalog-group.model';
import { MenuItemCatalogModel } from 'src/app/views/models/menu-item-catalog.model';
import { MenuAsideService } from 'src/app/core/_base/layout';
import { MatDialog } from '@angular/material';
import { ItemCatalogPopup } from 'src/app/views/component/popup/item-catalog/item-catalog.popup';
import { PriceFinderPipe } from './price-finder.pipe';
import { MenuItemCatalogPriceModel } from 'src/app/views/models/menu-item-catalog-price.model';
import { AppHotelService } from 'src/app/provider/app-hotel.service';
import { AppHotelModel } from 'src/app/views/models/app-hotel.model';


@Component({
  selector: 'kt-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {

  data: MenuItemCatalogModel[] = [];
  groups: MenuItemCatalogGroupModel[] = [];
  catalogGroups: CatalogCategory[];
  hotelData: AppHotelModel = null;



  itemID: number = null;


  constructor(
    public catalogServ: CatalogueService,
    private itemServ: ItemService,
    private caption: CaptionPipe,
    private sideServ: MenuAsideService,
    private dialog: MatDialog,
    private priceFinder: PriceFinderPipe,
    private appHotel: AppHotelService,
    private changeDetect: ChangeDetectorRef,
  ) {

  }


  async ngOnInit() {

    this.hotelData = await this.appHotel.getAppHotel(JSON.parse(localStorage.getItem('token_form')).app_hotel_id);

    this.sideServ.pathname$.next(window.location.pathname);
    const SECS = await this.itemServ.getItemsWithSectionId(157);
    this.itemID = SECS[0].id;
    this.catalogGroups = await this.catalogServ.getData(this.itemID);
    this.catalogGroups.forEach(group => {
      group.items.forEach(item => {
        item.name = this.caption.transform(item.name);
        item.description = this.priceFinder.transform(item.id).size;
        item.description = this.caption.transform(item.description);
        console.log(item)
        this.data.push(item);
      });

      this.groups.push(group.category);
    });
  }




  categoryName = (data: MenuItemCatalogGroupModel) => {
    return this.caption.transform(data.name);
  }

  priceCalc = (data: MenuItemCatalogModel) => {
    if (data.id) {
      const X = this.priceFinder.transform(data.id).activate_offer ? this.priceFinder.transform(data.id).offer_price : this.priceFinder.transform(data.id).price;
      return X;
    } else {
      return 0;
    }
  }

  sizeCalc = (data: MenuItemCatalogModel) => {
    if (data.id) {
      return this.priceFinder.transform(data.id).size;
    } else {
      return 0;
    }
  }

  editProduct(data: MenuItemCatalogModel) {
    const dialogRef = this.dialog.open(ItemCatalogPopup, { data, width: '1400px' });

    dialogRef.afterClosed().subscribe(() => {
      this.catalogServ.getData(this.itemID);
    });
  }

  async addProduct(data) {
    const CATALOG = new MenuItemCatalogModel(0, 0, 0, 0, '', '', [], '', '', new Date(), new Date(), 0, '', '', 0);
    CATALOG.menu_item_id = this.itemID;
    CATALOG.menu_item_catalog_group_id = data.data.menu_item_catalog_group_id;

    const NAME = {
      tr: '',
      en: ''
    };

    NAME[localStorage.getItem('language')] = data.data.name;

    CATALOG.name = JSON.stringify(NAME);

    const RESP = await this.catalogServ.postCatalog(CATALOG);

    const PRICE = new MenuItemCatalogPriceModel();
    PRICE.menu_item_catalog_id = RESP.id;
    PRICE.menu_item_id = RESP.menu_item_id;

    NAME[localStorage.getItem('language')] = data.data.description;

    PRICE.size = JSON.stringify(NAME);
    PRICE.price = data.data.menu_item_catalog_prices;
    PRICE.currency_code = this.hotelData.currency_code;

    await this.catalogServ.postPrice(PRICE);

    this.changeDetect.detectChanges();
    console.log(data);

  }
}
